/* eslint-disable quotes */
import { h } from 'vue';
import { vimeo } from '../../vimeo';

const body = `<h4>Carve model</h4>

<p>Carve through the model, adding edges on all faces crossed.</p>

<div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="${vimeo('566441454')}" loading="lazy"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
</div>

<ul class='shortcuts'>
    <li class='shortcuts__item'><b>Shortcuts:</b></li>
    <li class='shortcuts__item'><b>C</b>: Carve</li>
    <li class='shortcuts__item'><b>Shift-C</b>: Carve along straight line</li>
</ul>`;

export default function CarveTooltip() {
    return h('div', { innerHTML: body });
}
